(() => {
    const prepareImage = (img) => {
      if (!img || img.dataset.erFadeInitialized) return;
      if (img.getAttribute('loading') !== 'lazy') return;

      img.dataset.erFadeInitialized = 'true';

      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('er-image-loaded');
        return;
      }

      img.classList.add('er-lazy-fade');

      const loaded = () => {
        img.classList.add('er-image-loaded');
      };

      img.addEventListener('load', loaded, { once: true });
      img.addEventListener('error', loaded, { once: true });

      /* Catch images that loaded between checks */
      if (img.complete && img.naturalWidth > 0) {
        loaded();
      }
    };

    const initializeImages = (root = document) => {
      root.querySelectorAll?.('img[loading="lazy"]').forEach(prepareImage);

      if (root.matches?.('img[loading="lazy"]')) {
        prepareImage(root);
      }
    };

    initializeImages();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            initializeImages(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
